import { gql } from "@apollo/client";

export const CreateNewUserAssesmentCycle = gql`
  mutation createUserAssessmentCycle($input: UserInput!) {
    createUserAssessmentCycle(input: $input) {
      id
      cycleNumber
    }
  }
`;

export const forceAutoScoreForCycle = gql`
  mutation forceAutoScoreForCycle($userAssessmentCycleId: ID!) {
    forceAutoScoreForCycle(userAssessmentCycleId: $userAssessmentCycleId) {
      assessmentsEnqueued
      assessmentIds
    }
  }
`;
